import React from 'react';
import { Route, Routes } from 'react-router-dom';
import RootLayout from './components/RootLayout';
import About from './pages/About';
import DbArchive from './pages/database/DbArchive';
import AhojDb from './pages/database/DbIndex';
import SeqsimPage from './pages/database/SeqsimPage';
import UbsUniprotPage from './pages/database/UbsUniprotPage';
import Help from './pages/Help';
import Home from './pages/home/Home';
import Job from './pages/jobs/Job';
import Jobs from './pages/jobs/Jobs';
import Query from './pages/query/Query';

export default function App(): React.JSX.Element {
   return (
      <Routes>
         <Route element={<RootLayout />}>
            <Route path="/db" element={<AhojDb />} />
            <Route path="/db/seqsim" element={<SeqsimPage />} />
            <Route path="/db/archive" element={<DbArchive />} />
            <Route path="/db/ubs/:uniprotId" element={<UbsUniprotPage />} />
            <Route path="/">
               <Route index element={<Home />} />
               <Route path="/my-jobs" element={<Jobs />} />
               <Route path="/job/:jobId" element={<Job />} />
               <Route path="/job/:jobId/query/:queryLabel" element={<Query />} />
               <Route path="/db/entry/:entryKey" element={<Query />} />
            </Route>
            <Route path="/help" element={<Help />} />
            <Route path="/about" element={<About />} />
         </Route>
      </Routes>
   );
}
